/**
 * Entry-effect registry — maps legacy entry-effect codes (frozen by
 * the editor's `slide.effectEntry` field) to CSS classes from
 * `entry-effects.css`.
 *
 * Unknown / empty codes fall back to a no-op so a slide mounts
 * silently instead of throwing.
 */
export type EntryEffectCode =
  | 'fade'
  | 'rise'
  | 'zoom-in'
  | 'blur-in'
  | 'curtain-up'
  | 'curtain-left'
  | 'spark-burst'
  | 'letter-rise'
  | 'split-letter'
  | 'typewriter'
  | 'ken-burns'
  | 'iris-open'
  | 'iris-close'
  | 'parallax-rise'
  | 'cinematic-letterbox'
  | 'fade-soft';

export const ENTRY_EFFECT_CLASS: Record<EntryEffectCode, string> = {
  fade: 'preview-entry-fade',
  rise: 'preview-entry-rise',
  'zoom-in': 'preview-entry-zoom-in',
  'blur-in': 'preview-entry-blur-in',
  'curtain-up': 'preview-entry-curtain-up',
  'curtain-left': 'preview-entry-curtain-left',
  'spark-burst': 'preview-entry-spark-burst',
  'letter-rise': 'preview-entry-letter-rise',
  'split-letter': 'preview-entry-split-letter',
  typewriter: 'preview-entry-typewriter',
  'ken-burns': 'preview-entry-ken-burns',
  'iris-open': 'preview-entry-iris-open',
  'iris-close': 'preview-entry-iris-close',
  'parallax-rise': 'preview-entry-parallax-rise',
  'cinematic-letterbox': 'preview-entry-cinematic-letterbox',
  'fade-soft': 'preview-entry-fade-soft',
};

const KNOWN_CODES = new Set<string>(Object.keys(ENTRY_EFFECT_CLASS));

export function resolveEntryClass(code: string | undefined | null): string | null {
  if (!code) return null;
  if (!KNOWN_CODES.has(code)) return null;
  return ENTRY_EFFECT_CLASS[code as EntryEffectCode];
}
